import { useTranslation } from 'react-i18next';
import { GenericSettings } from '../components/GenericSettings';
import { NotificationEntityType } from 'types';
import { translations } from 'app/locales/i18n';

export const ProjectSettings = () => {
  const { t } = useTranslation();
  return (
    <GenericSettings
      entityType={NotificationEntityType.PROJECT}
      header={t(translations.projectListing.projectListing)}
      label={t(translations.projectListing.projects)}
      emptyTableText={t(translations.projectListing.noProjects)}
    />
  );
};
